import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=b0dfdf00&scoped=true"
import script from "./Conversation.vue?vue&type=script&lang=ts&setup=true"
export * from "./Conversation.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Conversation.vue?vue&type=style&index=0&id=b0dfdf00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dfdf00",
  null
  
)

export default component.exports